import { render, staticRenderFns } from "./ParticipationEventDocs.vue?vue&type=template&id=83a1069c&"
import script from "./ParticipationEventDocs.vue?vue&type=script&lang=js&"
export * from "./ParticipationEventDocs.vue?vue&type=script&lang=js&"
import style0 from "./ParticipationEventDocs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports